import { useEffect, useState } from "react";
import { HOMEPAGE } from "../../constants/PageTitleConstants";
import Carousel from "./Carousel";
import Slider from "./Slider";
import News from "../homepage/News";
import { HOMEPAGE_URL } from "../../constants/APIEndpointConstants";
import { makeGetRequest } from "../../rest/RestService";
import { useSelector } from "react-redux";
import { Loader } from "../general/Loader";
import { Helmet } from "react-helmet";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import PageNotFound from "../not-found/PageNotFound";

const Homepage = () => {
  const [response, setResponse] = useState({});
  const { code, error } = useSelector((state) => state.geolocation);
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  const [loader, setLoader] = useState(true);
  const history = useHistory();
  const ogURL = process.env.REACT_APP_FRONT_URL;
  const ogType = 'website';
  const ogTitle = HOMEPAGE;
  const ogImage = process.env.REACT_APP_POLITY_IMAGE;
  const twitterCard = 'summary';
  const ogImageAlt = 'Polity';
  const ogSiteName = 'Polity';
  useEffect(() => {
    if (code && hfData?.header) {
      setLoader(true);
      makeGetRequest(`${HOMEPAGE_URL}/${code}`)
        .then((res) => setResponse(res.data))
        .catch((err) => setResponse({ error: err.message }))
        .finally(() => {
          setLoader(false);
          ManageScroll(history);
        });
    }
  }, [code, history, hfData?.header]);
  return (
    <>
      {loader ? (
        <Loader />
      ) : response && !error && !hfError ? (
        <>
          <Helmet>
            <title>{HOMEPAGE}</title>
            <meta property="og:url" content={ogURL} />
            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:secure_url" content={ogImage} />
            <meta property="og:image:alt" content={ogImageAlt} />
            <meta property="og:site_name" content={ogSiteName} />            
            <meta name="twitter:card" content={twitterCard} />
          </Helmet>
          <Header data={hfData} />
          {response.slider && !response.slider.code && (
            <Carousel data={response} />
          )}
          {response.new_books && !response.new_books.code && (
            <Slider data={response.new_books} title={"New Books"} />
          )}
          {response.highlights && !response.highlights.code && (
            <Slider data={response.highlights} />
          )}
          <News data={response} />
          <Footer data={hfData} />
        </>
      ) : (
        <>
          <PageNotFound pageError={response?.error || hfError || error} />
        </>
      )}
    </>
  );
};

export default Homepage;
